module.exports = __webpack_public_path__ + "static/media/22.3bbe8b83.jpg";